
export class MathHelper {

    public static randomNumberInRange(min:number, max:number, decimals:number = 0):number {
        let randomNumber:number = min + (max - min) * Math.random();
        return Number(randomNumber.toFixed(decimals));
    }

    public static roundToDecimals(num:number, noOfDecimals:number):number {
        return Number((num).toFixed(noOfDecimals));
    }

    public static isInRange(value:number, min:number, max:number):boolean {
        return value >= min && value <= max;
    }
}